// LIBRARIES
import styled from "styled-components";

// MISC
import {
  BORDER_RADIUS,
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  MARGIN,
} from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const HamburgerMenuComponentContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${COLORS.Cultured};
  display: flex;
  flex-direction: column;
  z-index: 2400;
  background-color: ${COLORS.VividAuburn};
  padding: ${MARGIN.fix32};
`;

export const CloseButton = styled.button<{ biggerCursor?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${COLORS.VividAuburn};
  justify-content: flex-end;
  border: none;
  z-index: 1001;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  margin-left: auto;
`;

export const ButtonsBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${COLORS.RaisinBlack};
  border-radius: 30px;
  width: auto;
  height: 64px;
  padding: ${MARGIN.fix16};
  z-index: 10;
`;

export const Xbutton = styled.img``;

export const HeaderComponent = styled.div`
  display: flex;
`;

export const LanguageComponent = styled.div`
  font-family: ${FONT_FAMILY.poppins};
  font-size: ${FONT_SIZE.fix16};
  font-weight: ${FONT_WEIGHT.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${MARGIN.fix16};
`;

export const CardBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${MARGIN.max40};
  margin-top: 50px;
  width: 100%;
  z-index: 1;
`;

export const CirclePositionMiddle = styled.div`
  position: absolute;
  top: 42%;
  left: -92px;
`;

export const Button = styled.div<{
  biggerCursor?: boolean;
  isSelected?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${({ isSelected }) =>
    isSelected ? COLORS.RaisinBlack : "transparent"};
  padding: ${MARGIN.fix14};
  border: none;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  color: ${COLORS.Yellow};
  padding: ${MARGIN.max10} ${MARGIN.fix16};
  margin-bottom: 20px;
  transition: 0.3s background-color ease-out;
  border-radius: ${BORDER_RADIUS.radius21};
`;

export const Icon = styled.img``;

export const LanguageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
`;
